import { createSelector } from 'reselect';
import { brazeData } from 'store/saga/entities/bound';

const selectEmailBounceStatusIsLoaded = state => brazeData.loaded(state);
const selectEmailBounceStatusData = createSelector(
  state => state,
  selectEmailBounceStatusIsLoaded,
  (state, isLoaded) => (isLoaded ? brazeData.data(state) : { email: null, isBounced: false })
);
export const selectEmailBounceStatus = createSelector(
  selectEmailBounceStatusIsLoaded,
  selectEmailBounceStatusData,
  (isLoaded, { isBounced }) => (!isLoaded ? false : isBounced)
);
